jQuery(document).ready(function ($) {
    const our_spaces = new Swiper('.our-spaces__pages', {
        loop: true,

        slidesPerView: 1,

        spaceBetween: 24,

        slideClass: 'teaser',

        pagination: {
            el: '.our-spaces__pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: {
            delay: 8000,
        },
        speed: 500,

        //grabCursor: true,

        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });
});